import {
  loadHermesData,
  getInfo,
  getError,
  withHermes,
} from 'ha/modules/Hermes';
import NotFoundPage from 'ha/pages/NotFound';
import HermesNotFoundPage from 'ha/modules/Hermes/components/HermesNotFoundPage.lazy';
import SomethingWentWrongPage from 'ha/pages/SomethingWentWrongPage';

export default (store, getComponentsWithNotFound) => (nextState, callback) => {
  store.dispatch(loadHermesData(nextState.location.pathname)).then(() => {
    const state = store.getState();

    if (getError(state)) {
      return callback(null, { component: SomethingWentWrongPage });
    }

    const info = getInfo(state);

    if (!info) {
      return callback(null, { component: NotFoundPage });
    }

    if (!info.hasData) {
      return callback(null, {
        component: withHermes(HermesNotFoundPage),
      });
    }

    return callback(null, {
      getComponent: getComponentsWithNotFound(info.type),
    });
  });
};
